<button #elementPrueba type="button" class="nav-item-text" data-bs-toggle="collapse"  [attr.data-bs-target]="'#' + item.alias" [attr.aria-expanded]="item.alias === currentCategory" [attr.aria-controls]="item.alias">
   <span class="item-text-container">
      {{ item.nombreRecurso || item.categoria }}
   </span>
   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
   </svg>
   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
   </svg>
</button>
<div [class]="'collapse ' + (item.alias === currentCategory ? 'show' : '')" [id]="item.alias">
   <ul>
      <li class="nav-item" *ngFor="let subItem of item.recursos">
      <ng-container *ngIf="!subItem.subMenu; else elseTemplate">
         <a class="nav-link" [routerLink]="subItem.url" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" routerLinkActive="active" #menuItem="routerLinkActive" [attr.aria-current]="menuItem.isActive ? 'page' : undefined" (click)="actionResponsive($event)">{{ subItem.nombreRecurso }}</a>
      </ng-container>
      <ng-template #elseTemplate>
         <app-sidebar-modules [item]="subItem"></app-sidebar-modules>
      </ng-template>
      </li>
   </ul>
</div>
